import { render, staticRenderFns } from "./exchangeCode.vue?vue&type=template&id=c81da82a&scoped=true&"
import script from "./exchangeCode.vue?vue&type=script&lang=js&"
export * from "./exchangeCode.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCode.vue?vue&type=style&index=0&id=c81da82a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81da82a",
  null
  
)

export default component.exports